import { whatsappLink } from "@/config/site";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 pulse-ring"
    >
      <MessageCircle size={26} strokeWidth={1.8} className="fill-white" />
    </a>
  );
};
